'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@kiao-voice/ui-kit'
import { USER_USE_CASES, type UserUseCase } from '@kiao-voice/core'

interface UseCaseQuestionProps {
  /** A picked use case, or `null` for「跳過」. */
  onAnswer: (useCase: UserUseCase | null) => void
}

/**
 * 「你最想先用 KIAO Voice 做什麼？」: shown once, in place of the empty transcripts
 * list, to a member who has not answered it yet. What the answer does next is
 * the caller's call; this only asks.
 *
 * The options are plain row buttons rather than `RadioGroup`: one click is the
 * whole answer and it acts immediately, whereas a radio group reads as
 * "select, then confirm".
 */
export function UseCaseQuestion({ onAnswer }: UseCaseQuestionProps) {
  const { t } = useTranslation('web')
  return (
    <section className="use-case" aria-labelledby="use-case-heading">
      <h2 id="use-case-heading">{t('transcriptions.useCase.heading')}</h2>
      <p className="lead">{t('transcriptions.useCase.lead')}</p>
      <ul className="use-case-options" aria-label={t('transcriptions.useCase.optionsLabel')}>
        {USER_USE_CASES.map((useCase) => (
          <li key={useCase}>
            <button type="button" className="use-case-option" onClick={() => onAnswer(useCase)}>
              {t(`transcriptions.useCase.option.${useCase}`)}
            </button>
          </li>
        ))}
      </ul>
      <Button variant="ghost" size="sm" className="use-case-skip" onClick={() => onAnswer(null)}>
        {t('transcriptions.useCase.skip')}
      </Button>
    </section>
  )
}
